import { render, staticRenderFns } from "./CuadreCaja.vue?vue&type=template&id=2ae596f8&"
import script from "./CuadreCaja.vue?vue&type=script&lang=js&"
export * from "./CuadreCaja.vue?vue&type=script&lang=js&"
import style0 from "./CuadreCaja.vue?vue&type=style&index=0&id=2ae596f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports